export type EditorCompletionState = "complete" | "partial" | "empty";

export type EditorCompletion = {
  state: EditorCompletionState;
  missing: string[];
};

export type CompletionRequirement = {
  label: string;
  value: unknown;
};

const HTML_TAG_PATTERN = /<[^>]*>/g;

export function hasEditorValue(value: unknown) {
  if (typeof value === "string") {
    return value.replace(HTML_TAG_PATTERN, "").replace(/&nbsp;/g, " ").trim().length > 0;
  }
  return Boolean(value);
}

export function getCompletionResult(requirements: CompletionRequirement[]): EditorCompletion {
  const missing = requirements
    .filter((requirement) => !hasEditorValue(requirement.value))
    .map((requirement) => requirement.label);
  const completed = requirements.length - missing.length;
  const state = missing.length === 0 && requirements.length > 0
    ? "complete"
    : completed > 0
      ? "partial"
      : "empty";

  return { state, missing };
}

export function getCompletionDescription(result: EditorCompletion) {
  if (result.state === "complete") return "Tüm gerekli alanlar dolu";
  const prefix = result.state === "empty" ? "Henüz başlanmadı. Gerekli alanlar" : "Eksik alanlar";
  return `${prefix}: ${result.missing.join(", ")}`;
}
